/** Published company and registration details; keep these values unchanged. */
export const legalFooter = {
  "company": "深圳市福美慧科技有限公司",
  "gongAn": "粤公网安备44030002012545号",
  "gongAnUrl": "https://beian.mps.gov.cn/#/query/webSearch?code=44030002012545",
  "icp": "粤ICP备2026039599号",
  "icpUrl": "https://beian.miit.gov.cn/",
  "address": "深圳市光明区马田街道将围社区将围旧村将石路第一排第3栋1001",
  "phone": "18898476526"
} as const;
